import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Dauert’s doch was länger/ kürzer?',
  text: {
    [OrderMethod.Pickup]:
      'Erwartete Abholzeit: <strong>{{date}}</strong> um <strong>{{time}}</strong><br/> Bei Bedarf kannst du die Zeit hier ändern.',
    [OrderMethod.OnSite]:
      'Erwartete Abholzeit: <strong>{{date}}</strong> um <strong>{{time}}</strong><br/> Bei Bedarf kannst du die Zeit hier ändern.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'Erwartete Lieferzeit: <strong>{{date}}</strong> um <strong>{{time}}</strong><br/> Bei Bedarf kannst du die Zeit hier ändern.',
      [DeliveryMode.External]: 'Der Fahrer wird die Bestellung um <strong>{{time}}{{confidenceLabel}}</strong> abholen',
    },
  },
  labels: {
    today: 'Heute',
  },
  confidence_labels: {
    estimated: ' (geschätzt!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Neue Abholzeit Bestätigen',
    confirm_delivery: 'Neue Lieferzeit bestätigen',
  },
  confirmation_modal: {
    description: 'Bist du sicher, dass du die Zeit von {{currentPickupTime}} auf {{newPickupTime}} ändern willst?',
    ok_button_text: 'Neue Zeit bestätigen',
    cancel_button_text: 'Nein, zurück zur vorherigen Zeit',
  },
};
